/**
 * Global member portal links configuration.
 * Set USE_NEW_MEMBER_PORTAL to true to switch to the new member portal once it is ready.
 */
export const USE_NEW_MEMBER_PORTAL = false;

export const OLD_MEMBER_PORTAL_BASE = "https://www.mpfcanada.ca/mpfapp/faces/login";
export const NEW_MEMBER_PORTAL_URL = "/member-ui/login/MPF/Member";

/**
 * Gets the member portal login URL based on active portal configuration and language.
 * @param lang Current language ('en' | 'fr' | string)
 */
export function getMemberPortalUrl(lang: "en" | "fr" | string): string {
  if (USE_NEW_MEMBER_PORTAL) {
    const cleanLang = lang === "fr" ? "fr" : "en";
    return `${NEW_MEMBER_PORTAL_URL}/${cleanLang}`;
  } else {
    return OLD_MEMBER_PORTAL_BASE;
  }

}





